(function () {
  if (window.innerWidth >= 990) {
    const elements = document.querySelectorAll('[data-words-fade-animation] h2');
    // 记录当前单词的顺序
    let wordCount = 1;
    // 每个单词包裹 span
    function wrapWordsInSpan(node) {
      if (node.nodeType === Node.TEXT_NODE) { // 只处理文本节点
        let text = node.textContent;
        // 用正则表达式替换每个单词，包裹在 <span> 标签中且添加动态样式
        let wrappedText = text.replace(/(\S|\s)/g, (match) => {
          return `<span>${match}</span>`;
          //  style="--animate-order: ${wordCount++};"
        });
        const spanContainer = document.createElement('span');
        spanContainer.innerHTML = wrappedText;
        // 替换原始文本节点
        node.replaceWith(...spanContainer.childNodes);
      } else if (node.nodeType === Node.ELEMENT_NODE) { // 处理元素节点
        for (let child of node.childNodes) {
          // 忽略已经是 <span> 的子节点，避免重复处理
          if (child.nodeName !== 'SPAN') {
            wrapWordsInSpan(child);
          }
        }
      }
    }

    for (const element of elements) {
      wrapWordsInSpan(element);
      wordCount = 1;
    }
  }
})();

window.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth >= 990) {
    gsap.registerPlugin(ScrollTrigger);

    const list = document.querySelectorAll('[data-words-fade-animation]');
    for (const content of list) {

      // 获取所有 span 和 p 标签元素
      const spans = content.querySelectorAll('span');
      const paragraphs = content.querySelectorAll('p');

      const contentHeight = content.offsetHeight;

      // 使用 ScrollTrigger 来控制滚动时的淡入效果
      ScrollTrigger.create({
        trigger: content, // 触发的元素
        start: 'top bottom-=100', // 当 .common-header 的顶部接触视口底部时开始动画
        end: `top+=${contentHeight / 2} center`, // 增加偏移量，确保元素正中央到达视口正中央时结束
        scrub: 1, // 设置为平滑过渡，支持反向滚动回退
        markers: false,
        onUpdate: (self) => {
          let progress = self.progress; // 进度值，范围从 0 到 1

          // 根据滚动的进度值计算显示的单词数量
          let visibleWords = Math.floor(progress * spans.length);

          // 使用 gsap stagger 来逐个淡入
          spans.forEach((span, index) => {
            if (index < visibleWords) {
              gsap.to(span, {
                opacity: 1,
                duration: 0.5,
                stagger: {
                  amount: 1, // 控制每个单词之间的延迟
                  from: "start", // 从第一个单词开始
                },
                ease: "power2.out", // 平滑过渡
                overwrite: "auto", // 防止冲突
                immediateRender: false,
              });
            } else {
              gsap.to(span, {
                opacity: 0.2,
                duration: 0.5,
              });
            }
          });

          // 只有当所有 span 的透明度为 1 时，才开始让 p 标签的透明度变化
          if (visibleWords === spans.length) {
            paragraphs.forEach((p) => {
              gsap.to(p, {
                opacity: 1, // 透明度从 0.2 到 1
                duration: 0.5,
                ease: "power2.out",
              });
            });
          } else {
            // 如果回退了，恢复 p 标签透明度
            paragraphs.forEach((p) => {
              gsap.to(p, {
                opacity: 0.2, // 恢复透明度为 0.2
                duration: 0.5,
                ease: "power2.out",
              });
            });
          }
        },
      });
    }
  }


  let lastHeight = document.documentElement.scrollHeight;

  // 定义检查函数
  function checkHeightChange() {
    const currentHeight = document.documentElement.scrollHeight;
    if (currentHeight !== lastHeight) {
      // 刷新 ScrollTrigger
      ScrollTrigger.refresh();
      lastHeight = currentHeight;
    }
  }
  const mutationObserver = new MutationObserver(() => {
    checkHeightChange();
  });
  mutationObserver.observe(document.documentElement, {
    subtree: true,       // 监听所有后代节点
    childList: true,     // 监听子节点增删
    attributes: false,    // 监听属性变化
    characterData: true, // 监听文本内容变化
  });
  // 添加防抖函数，避免频繁检查
  const debounceCheck = debounce(checkHeightChange, 100);

  window.addEventListener("resize", debounceCheck);

  function debounce(func, delay) {
    let timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, arguments), delay);
    };
  }
});

window.addEventListener("load", () => {
  ScrollTrigger.refresh();
});

window.addEventListener("resize", () => {
  ScrollTrigger.refresh();
});